import React from 'react'
import RegisterGoogleSimple from '../../../common/GoogleOriginalDesign/Foodslabo/Simple/RegisterGoogleSimple'

export default function GoogleDemandRegisterSapporo() {
    return (
        <RegisterGoogleSimple
            reasonPoint1Images={[
                {
                    src: '/pages/google/foodslabo/demand_register_sapporo/reason_point1_img1.png',
                    alt: '札幌の限定求人詳細1枚目',
                },
                {
                    src: '/pages/google/foodslabo/demand_register_sapporo/reason_point1_img2.png',
                    alt: '札幌の限定求人詳細2枚目',
                },
                {
                    src: '/pages/google/foodslabo/demand_register_sapporo/reason_point1_img3.png',
                    alt: '札幌の限定求人詳細3枚目',
                },
            ]}
            signupPath='signup?channel=dsp'
        />
    )
}
